import { Injectable } from '@angular/core';
import { IPublicClientApplication } from '@azure/msal-browser';
import { BehaviorSubject, Observable, from } from 'rxjs';
import { filter, take, tap } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class MsalInitializerService {
  private entraInitializedSubject = new BehaviorSubject<boolean>(false);
  private b2cInitializedSubject = new BehaviorSubject<boolean>(false);

  /**
   * Initialize the Entra MSAL instance
   * @param msalInstance The Entra MSAL instance to initialize
   */
  async initializeEntraInstance(msalInstance: IPublicClientApplication): Promise<void> {
    if (this.entraInitializedSubject.getValue()) {
      console.log('[MSAL] Entra instance already initialized');
      return;
    }
    
    try {
      console.log('[MSAL] Initializing Entra instance...');
      await msalInstance.initialize();
      this.entraInitializedSubject.next(true);
      console.log('[MSAL] Entra instance initialized successfully');
    } catch (error) {
      console.error('[MSAL] Failed to initialize Entra instance:', error);
      this.entraInitializedSubject.next(false);
      throw error;
    }
  }

  /**
   * Initialize the B2C MSAL instance
   * @param msalInstance The B2C MSAL instance to initialize
   */
  async initializeB2CInstance(msalInstance: IPublicClientApplication): Promise<void> {
    if (this.b2cInitializedSubject.getValue()) {
      console.log('[MSAL] B2C instance already initialized');
      return;
    }
    
    try {
      console.log('[MSAL] Initializing B2C instance...');
      await msalInstance.initialize();
      this.b2cInitializedSubject.next(true);
      console.log('[MSAL] B2C instance initialized successfully');
    } catch (error) {
      console.error('[MSAL] Failed to initialize B2C instance:', error);
      this.b2cInitializedSubject.next(false);
      throw error;
    }
  }

  /**
   * Wait for Entra instance to be initialized
   */
  waitForEntraInitialization(): Observable<boolean> {
    return this.entraInitializedSubject.asObservable().pipe(
      filter(initialized => initialized),
      take(1)
    );
  }

  /**
   * Wait for B2C instance to be initialized
   */
  waitForB2CInitialization(): Observable<boolean> {
    return this.b2cInitializedSubject.asObservable().pipe(
      filter(initialized => initialized),
      take(1)
    );
  }
}
